import { CircularSpinner } from '@festina-life/ui/feedback'

import { useOperationsContext } from '../../../workspace/operationsContext'

export const WorkspaceLoadingStatus = () => {
  const { isLoading: isLoadingOperations, isLoadingErrors } =
    useOperationsContext()

  return isLoadingOperations || isLoadingErrors ? (
    <CircularSpinner className="size-4" />
  ) : null
}
